export default __webpack_public_path__ + "static/media/verified.c2a658b2.png";